import LevelUp from './LevelUp';
import { connect } from 'react-redux';
import { shouldShowTooltip as _shouldShowTooltip, tooltipDetails as _tooltipDetails } from '../../state/actions/tooltip';
import { setGameId as _setGameId } from '../../state/actions/game';
import { checkDynamicGameRooms } from '../../state/query/games/utils';
var nextGameUnlock = function nextGameUnlock(data, level, isDynamicGameRooms) {
  var games = isDynamicGameRooms ? data.flatMap(function (room) {
    return room.games;
  }) : data;
  return games.find(function (game) {
    return game.UNLOCK_LEVEL == level;
  });
};
var mapStateToProps = function mapStateToProps(state) {
  var _state$gameRooms, _state$slotGames;
  var isDynamicGameRooms = checkDynamicGameRooms();
  var gameData = isDynamicGameRooms ? (_state$gameRooms = state.gameRooms) === null || _state$gameRooms === void 0 ? void 0 : _state$gameRooms.data : (_state$slotGames = state.slotGames) === null || _state$slotGames === void 0 || (_state$slotGames = _state$slotGames.gameList) === null || _state$slotGames === void 0 || (_state$slotGames = _state$slotGames[0]) === null || _state$slotGames === void 0 ? void 0 : _state$slotGames.games;
  return {
    coins: state.levelInfo.previousLevelBonusCoins,
    maxBet: state.levelInfo.maxBet,
    gameUnlock: gameData && nextGameUnlock(gameData, state.levelInfo.level, isDynamicGameRooms)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    tooltipDetails: function tooltipDetails(value) {
      dispatch(_tooltipDetails(value));
    },
    shouldShowTooltip: function shouldShowTooltip(value) {
      dispatch(_shouldShowTooltip(value));
    },
    setGameId: function setGameId(gameId) {
      dispatch(_setGameId(gameId));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LevelUp);